export default "__VITE_ASSET__1ca43a48__"